export const sevenDaysInMS = 7 * 24 * 60 * 60 * 1000;

interface SelectionOption<Name, Value> {
  name: Name;
  value: Value;
}

export function mapToSelectionOption<Id, Name>(object: {
  id: Id;
  name: Name;
}): SelectionOption<Name, Id> {
  return {
    name: object.name,
    value: object.id,
  };
}
